import { connect } from 'react-redux';
import {
    requestHotel,
    addHotelContact,
    removeHotelContact,
    editHotelContact
} from '../modules/hotels';

import HotelUsers from '../components/HotelUsers';

const mapDispatchToProps = {
    requestHotel,
    addHotelContact,
    removeHotelContact,
    editHotelContact
};

const mapStateToProps = (state, ownProps) => ({
    isFetching: state.hotels.selectedHotel.isFetching,
    needFetch: state.hotels.selectedHotel.needFetch,
    hasError: state.hotels.selectedHotel.hasError,
    hotel: state.hotels.selectedHotel.hotel,
    perms: state.auth.perms,
    id: ownProps.params.id,
    action: ownProps.params.action ? ownProps.params.action : 'view',
});

export default connect(mapStateToProps, mapDispatchToProps)(HotelUsers);



// WEBPACK FOOTER //
// src/routes/hotels/containers/HotelUsersContainer.js